import { registry, type SlotName, type SlotProps } from './extension-points';
import { useSession } from './session';

/** Pinta los paneles que los paquetes activos registraron en una ranura. */
export function Slot({ name, ...props }: SlotProps & { name: SlotName }) {
  const { has } = useSession();
  const defs = registry.slotsFor(name, has, props.project?.typeCode ?? props.task?.project.typeCode);
  if (!defs.length) return null;
  return (
    <>
      {defs.map((d, i) => {
        const C = d.component;
        return <C key={`${d.slot}-${i}`} {...props} />;
      })}
    </>
  );
}
